import { Directive, TemplateRef } from '@angular/core';

@Directive({
  selector: '[tagAutocompleteContent]'
})
export class TagAutocompleteContentDirective {
  constructor( public tpl: TemplateRef<any> ) {
  }
}
